import { localStorageFav } from '../constants';
import { FETCH_FAVOURITES, ADD_FAVOURITES, REMOVE_FAVOURITES } from './types';

///////////
// Favourites //
///////////

export function fetchFavourites() {
	const request = JSON.parse(localStorage.getItem(localStorageFav)) || [];
	return {
		type: FETCH_FAVOURITES,
		payload: request
	};
}

export function addFavourites(id) {
	let storedData = JSON.parse(localStorage.getItem(localStorageFav)) || [];
	if(!storedData) {
		storedData = [id.toString()];
	} else {
		storedData.push(id.toString());
	}
	localStorage.removeItem(localStorageFav);
	localStorage.setItem(localStorageFav,	JSON.stringify(storedData));

	return {
		type: ADD_FAVOURITES,
		payload: id
	};
}

export function removeFavourites(id) {
	let storedData = JSON.parse(localStorage.getItem(localStorageFav)) || [];
	const rmKey = storedData.indexOf(id.toString());
	if(rmKey !== -1) {
	storedData.splice(rmKey, 1);
	}
	localStorage.removeItem(localStorageFav);
	localStorage.setItem(localStorageFav, JSON.stringify(storedData));

	return {
		type: REMOVE_FAVOURITES,
		payload: rmKey
	};
}
